import firebase from "firebase";
import {db, storage} from "../../main";

const state = {
  inboxToDoListId: null,
  currentToDoListName: '',
  removedFromInvitationCollaboratorObject: null,
  sortTaskListProperties: {},
  filterTaskListProperties: {},
  isCollaborativeListOwner: false,
  isCollaborativeListAdministrator: false,
}

const getters = {
  inboxToDoListId: state => {
    return state.inboxToDoListId
  },
  currentToDoListName: state => {
    return state.currentToDoListName
  },
  removedFromInvitationCollaboratorObject: state => {
    return state.removedFromInvitationCollaboratorObject
  },
  sortTaskListProperties: state => {
    return state.sortTaskListProperties
  },
  filterTaskListProperties: state => {
    return state.filterTaskListProperties
  },
  isCollaborativeListOwner: state => {
    return state.isCollaborativeListOwner
  },
  isCollaborativeListAdministrator: state => {
    return state.isCollaborativeListAdministrator
  }
}

const mutations = {
  setInboxToDoListId: (state, value) => {
    state.inboxToDoListId = value
  },
  setCurrentToDoListName: (state, value) => {
    state.currentToDoListName = value
  },
  setRemovedFromInvitationCollaboratorObject: (state, value) => {
    state.removedFromInvitationCollaboratorObject = value
  },
  setSortTaskListProperties: (state, value) => {
    state.sortTaskListProperties = value
  },
  setFilterTaskListProperties: (state, value) => {
    state.filterTaskListProperties = value
  },
  setIsCollaborativeListOwner: (state, value) => {
    state.isCollaborativeListOwner = value
  },
  setIsCollaborativeListAdministrator: (state, value) => {
    state.isCollaborativeListAdministrator = value
  }
}

const actions = {
  setInboxToDoListId: ({commit}, payload) => {
    commit('setInboxToDoListId', payload)
  },
  setCurrentToDoListName: ({commit}, payload) => {
    commit('setCurrentToDoListName', payload)
  },
  setRemovedFromInvitationCollaboratorObject: ({commit}, payload) => {
    commit('setRemovedFromInvitationCollaboratorObject', payload)
  },
  setSortTaskListProperties: ({commit}, payload) => {
    commit('setSortTaskListProperties', payload)
  },
  setFilterTaskListProperties: ({commit}, payload) => {
    commit('setFilterTaskListProperties', payload)
  },
  setIsCollaborativeListOwner: ({commit}, payload) => {
    commit('setIsCollaborativeListOwner', payload)
  },
  setIsCollaborativeListAdministrator: ({commit}, payload) => {
    commit('setIsCollaborativeListAdministrator', payload)
  },
  createNewPersonalList: ({state, rootGetters}, payload) => {
    const user = rootGetters.user

    const ownerId = user.data.id
    const ownerName = user.data.displayName

    const date = new Date();
    const toDoListCreationTime = date.getTime()

    db.collection('personal_to_do_lists')
      .add({
        ownerId: ownerId,
        ownerName: ownerName,
        toDoListCreationDate: firebase.firestore.FieldValue.serverTimestamp(),
        toDoListCreationTime: toDoListCreationTime,
        toDoListDescription: payload.toDoListDescription ? payload.toDoListDescription : '',
        toDoListId: null,
        toDoListName: payload.toDoListName
      })
      .then(docRef => {
        const toDoListId = docRef.id
        db.collection('personal_to_do_lists')
          .doc(toDoListId)
          .update('toDoListId', toDoListId)
      })
  },
  createNewCollaborativeList: ({state, rootGetters}, payload) => {
    const user = rootGetters.user

    const ownerId = user.data.id
    const ownerName = user.data.displayName

    const date = new Date();
    const toDoListCreationTime = date.getTime()

    let toDoListId;

    db
      .collection('collaborative_to_do_lists')
      .add({
        ownerId: ownerId,
        ownerName: ownerName,
        toDoListCreationDate: firebase.firestore.FieldValue.serverTimestamp(),
        toDoListCreationTime: toDoListCreationTime,
        toDoListDescription: payload.toDoListDescription ? payload.toDoListDescription : '',
        toDoListId: null,
        toDoListName: payload.toDoListName,
        toDoListCollaboratorId: payload.toDoListCollaboratorId
      })
      .then(docRef => {
        toDoListId = docRef.id
        db.collection('collaborative_to_do_lists')
          .doc(toDoListId)
          .update('toDoListId', toDoListId)
          .then(docRef => {
            // notify the current users about the collaborative list invitation
            const date = new Date();
            const notificationCreationTime = date.getTime()

            const collaborativeListInvitationNotification = {
              collaborativeToDoListId: toDoListId,
              notificationMessage: "You have been invited to \"" + payload.toDoListName + '\"',
              notificationType: 'Invite Collaborator',
              notificationCreationTime: notificationCreationTime,
              notificationCreationDate: firebase.firestore.FieldValue.serverTimestamp()
            }

            // send the invitation notification to every invited user EXCEPT the owner
            const toDoListCollaboratorId = payload.toDoListCollaboratorId
            toDoListCollaboratorId.forEach(collaboratorId => {
              if (collaboratorId !== ownerId) {
                db
                  .collection('users/' + collaboratorId + '/notifications')
                  .add(collaborativeListInvitationNotification)
              }
            })

            // update the user_collaborative_to_do_list_participation for each user invited into the collaborative list
            const collaboratorListArray = payload.collaboratorListArray
            const collaboratorRoleArray = payload.collaboratorRoleArray

            collaboratorListArray.forEach((collaborator, index) => {

              const userCollaborativeToDoListParticipatedObject = {
                collaborativeToDoListId: toDoListId,
                collaborativeToDoListName: payload.toDoListName,
                collaborativeToDoListRole: collaboratorRoleArray[index],
                collaboratorId: collaborator.id,
                collaboratorName: collaborator.name,
                collaboratorEmail: collaborator.email,
                collaboratorProfilePictureUrl: collaborator.profilePictureUrl !== undefined ? collaborator.profilePictureUrl : null,
                owner: collaborator.id === ownerId
              }

              db
                .collection('users/' + collaborator.id + '/user_collaborative_to_do_list_participation')
                .add(userCollaborativeToDoListParticipatedObject)
            })

          })
      })
  },
  createNewPersonalTask: ({state, rootGetters}, payload) => {
    const user = rootGetters.user

    const assigneeId = user.data.id
    const assigneeName = user.data.displayName

    const date = new Date();
    const taskCreationTime = date.getTime()

    if (rootGetters.homeSelectedComponent === 'inbox') {
      db.collection('inbox_to_do_lists/' + payload.toDoListId + '/tasks')
        .add({
          assigneeId: assigneeId,
          assigneeName: assigneeName,
          attachment: null,
          completed: false,
          description: payload.description,
          dueDate: payload.dueDate !== null ? firebase.firestore.Timestamp.fromDate(methods.convertStringToDate(payload.dueDate)) : null,
          dueTime: payload.dueDate !== null ? methods.convertStringToDate(payload.dueDate).getTime() : 0,
          inboxTask: true,
          location: payload.location,
          priority: payload.priority,
          reminderDate: null,
          reminderTime: 0,
          taskCreationDate: firebase.firestore.FieldValue.serverTimestamp(),
          taskCreationTime: taskCreationTime,
          taskId: null,
          taskName: payload.taskName,
          taskType: payload.taskType,
          toDoListId: payload.toDoListId,
          toDoListName: payload.toDoListName
        })
        .then(docRef => {
          const taskId = docRef.id

          // upload image to the storage and update the attachment link in the task
          if (payload.attachmentFile) {
            // create a storage ref
            let storageRef = storage.ref('inboxTaskImages').child(payload.toDoListId).child(methods.uuidv4() + '.jpg')
            // upload file
            storageRef.put(payload.attachmentFile)
              .then(snapshot => {
                snapshot.ref.getDownloadURL().then(downloadUrl => {
                  db.collection('inbox_to_do_lists/' + payload.toDoListId + '/tasks')
                    .doc(taskId)
                    .update('attachment', downloadUrl)
                })
              })
          }

          db.collection('inbox_to_do_lists/' + payload.toDoListId + '/tasks')
            .doc(taskId)
            .update('taskId', taskId)
        })
    } else {
      db.collection('personal_to_do_lists/' + payload.toDoListId + '/tasks')
        .add({
          assigneeId: assigneeId,
          assigneeName: assigneeName,
          attachment: null,
          completed: false,
          description: payload.description,
          dueDate: payload.dueDate !== null ? firebase.firestore.Timestamp.fromDate(methods.convertStringToDate(payload.dueDate)) : null,
          dueTime: payload.dueDate !== null ? methods.convertStringToDate(payload.dueDate).getTime() : 0,
          inboxTask: false,
          location: payload.location,
          priority: payload.priority,
          reminderDate: null,
          reminderTime: 0,
          taskCreationDate: firebase.firestore.FieldValue.serverTimestamp(),
          taskCreationTime: taskCreationTime,
          taskId: null,
          taskName: payload.taskName,
          taskType: payload.taskType,
          toDoListId: payload.toDoListId,
          toDoListName: payload.toDoListName
        })
        .then(docRef => {
          const taskId = docRef.id

          // upload image to the storage and update the attachment link in the task
          if (payload.attachmentFile) {
            // create a storage ref
            let storageRef = storage.ref('personalTaskImages').child(payload.toDoListId).child(methods.uuidv4() + '.jpg')
            // upload file
            storageRef.put(payload.attachmentFile)
              .then(snapshot => {
                snapshot.ref.getDownloadURL().then(downloadUrl => {
                  db.collection('personal_to_do_lists/' + payload.toDoListId + '/tasks')
                    .doc(taskId)
                    .update('attachment', downloadUrl)
                })
              })
          }

          db.collection('personal_to_do_lists/' + payload.toDoListId + '/tasks')
            .doc(taskId)
            .update('taskId', taskId)
        })
    }
  },
  createNewCollaborativeTask: ({state, rootGetters}, payload) => {
    const date = new Date();
    const taskCreationTime = date.getTime()

    db.collection('collaborative_to_do_lists/' + payload.toDoListId + '/tasks')
      .add({
        assigneeId: payload.assigneeId,
        assigneeName: payload.assigneeName,
        attachment: null,
        completed: false,
        description: payload.description,
        dueDate: payload.dueDate !== null ? firebase.firestore.Timestamp.fromDate(methods.convertStringToDate(payload.dueDate)) : null,
        dueTime: payload.dueDate !== null ? methods.convertStringToDate(payload.dueDate).getTime() : 0,
        inboxTask: false,
        location: payload.location,
        priority: payload.priority,
        taskCreationDate: firebase.firestore.FieldValue.serverTimestamp(),
        taskCreationTime: taskCreationTime,
        taskId: null,
        taskName: payload.taskName,
        taskType: payload.taskType,
        toDoListId: payload.toDoListId,
        toDoListName: payload.toDoListName
      })
      .then(docRef => {
        const taskId = docRef.id

        // upload image to the storage and update the attachment link in the task
        if (payload.attachmentFile) {
          // create a storage ref
          let storageRef = storage.ref('collaborativeTaskImages').child(payload.toDoListId).child(methods.uuidv4() + '.jpg')
          // upload file
          storageRef.put(payload.attachmentFile)
            .then(snapshot => {
              snapshot.ref.getDownloadURL().then(downloadUrl => {
                db.collection('collaborative_to_do_lists/' + payload.toDoListId + '/tasks')
                  .doc(taskId)
                  .update('attachment', downloadUrl)
              })
            })
        }

        db.collection('collaborative_to_do_lists/' + payload.toDoListId + '/tasks')
          .doc(taskId)
          .update('taskId', taskId)
      })
  },
  updatePersonalTask: ({state, rootGetters}, payload) => {
    const user = rootGetters.user

    const assigneeId = user.data.id
    const assigneeName = user.data.displayName

    if (payload.inboxTask) {
      db.collection('inbox_to_do_lists/' + payload.toDoListId + '/tasks')
        .doc(payload.taskId)
        .update({
          assigneeId: assigneeId,
          assigneeName: assigneeName,
          attachment: payload.initialAttachmentUrl,
          completed: payload.completed,
          description: payload.description,
          dueDate: payload.dueDate !== null ? firebase.firestore.Timestamp.fromDate(methods.convertStringToDate(payload.dueDate)) : null,
          dueTime: payload.dueDate !== null ? methods.convertStringToDate(payload.dueDate).getTime() : 0,
          inboxTask: payload.inboxTask,
          location: payload.location,
          priority: payload.priority,
          reminderDate: payload.reminderDate,
          reminderTime: payload.reminderTime,
          taskCreationDate: payload.taskCreationDate,
          taskCreationTime: payload.taskCreationTime,
          taskId: payload.taskId,
          taskName: payload.taskName,
          taskType: payload.taskType,
          toDoListId: payload.toDoListId,
          toDoListName: payload.toDoListName
        })
        .then(() => {
          // upload image to the storage and update the attachment link in the task
          if (payload.initialAttachmentUrl !== null && payload.attachmentUrl != null && payload.initialAttachmentUrl !== payload.attachmentUrl) {
            // remove initialAttachmentUrl and upload attachmentUrl
            const attachmentObject = payload.initialAttachmentUrl

            if (attachmentObject !== null) {
              const attachment = attachmentObject.toString()
              const attachmentRef = storage.refFromURL(attachment)

              attachmentRef.delete()
            }

            // create a storage ref
            let storageRef = storage.ref('inboxTaskImages').child(payload.toDoListId).child(methods.uuidv4() + '.jpg')
            // upload file
            storageRef.put(payload.attachmentFile)
              .then(snapshot => {
                snapshot.ref.getDownloadURL().then(downloadUrl => {
                  db.collection('inbox_to_do_lists/' + payload.toDoListId + '/tasks')
                    .doc(payload.taskId)
                    .update('attachment', downloadUrl)
                })
              })
          } else if (payload.initialAttachmentUrl !== null && payload.attachmentUrl === null) {
            // remove initialAttachmentUrl
            const attachmentObject = payload.initialAttachmentUrl

            if (attachmentObject !== null) {
              const attachment = attachmentObject.toString()
              const attachmentRef = storage.refFromURL(attachment)

              attachmentRef.delete()

              db.collection('inbox_to_do_lists/' + payload.toDoListId + '/tasks')
                .doc(payload.taskId)
                .update('attachment', null)
            }

          } else if (payload.initialAttachmentUrl === null && payload.attachmentUrl !== null) {
            // directly upload attachmentUrl
            // create a storage ref
            let storageRef = storage.ref('inboxTaskImages').child(payload.toDoListId).child(methods.uuidv4() + '.jpg')
            // upload file
            storageRef.put(payload.attachmentFile)
              .then(snapshot => {
                snapshot.ref.getDownloadURL().then(downloadUrl => {
                  db.collection('inbox_to_do_lists/' + payload.toDoListId + '/tasks')
                    .doc(payload.taskId)
                    .update('attachment', downloadUrl)
                })
              })
          }
        })
    } else {
      db.collection('personal_to_do_lists/' + payload.toDoListId + '/tasks')
        .doc(payload.taskId)
        .update({
          assigneeId: assigneeId,
          assigneeName: assigneeName,
          attachment: payload.initialAttachmentUrl,
          completed: payload.completed,
          description: payload.description,
          dueDate: payload.dueDate !== null ? firebase.firestore.Timestamp.fromDate(methods.convertStringToDate(payload.dueDate)) : null,
          dueTime: payload.dueDate !== null ? methods.convertStringToDate(payload.dueDate).getTime() : 0,
          inboxTask: payload.inboxTask,
          location: payload.location,
          priority: payload.priority,
          reminderDate: payload.reminderDate,
          reminderTime: payload.reminderTime,
          taskCreationDate: payload.taskCreationDate,
          taskCreationTime: payload.taskCreationTime,
          taskId: payload.taskId,
          taskName: payload.taskName,
          taskType: payload.taskType,
          toDoListId: payload.toDoListId,
          toDoListName: payload.toDoListName
        })
        .then(() => {
          // upload image to the storage and update the attachment link in the task
          if (payload.initialAttachmentUrl !== null && payload.attachmentUrl != null && payload.initialAttachmentUrl !== payload.attachmentUrl) {
            // remove initialAttachmentUrl and upload attachmentUrl
            const attachmentObject = payload.initialAttachmentUrl

            if (attachmentObject !== null) {
              const attachment = attachmentObject.toString()
              const attachmentRef = storage.refFromURL(attachment)

              attachmentRef.delete()
            }

            // create a storage ref
            let storageRef = storage.ref('personalTaskImages').child(payload.toDoListId).child(methods.uuidv4() + '.jpg')
            // upload file
            storageRef.put(payload.attachmentFile)
              .then(snapshot => {
                snapshot.ref.getDownloadURL().then(downloadUrl => {
                  db.collection('personal_to_do_lists/' + payload.toDoListId + '/tasks')
                    .doc(payload.taskId)
                    .update('attachment', downloadUrl)
                })
              })
          } else if (payload.initialAttachmentUrl !== null && payload.attachmentUrl === null) {
            // remove initialAttachmentUrl
            const attachmentObject = payload.initialAttachmentUrl

            if (attachmentObject !== null) {
              const attachment = attachmentObject.toString()
              const attachmentRef = storage.refFromURL(attachment)

              attachmentRef.delete()

              db.collection('personal_to_do_lists/' + payload.toDoListId + '/tasks')
                .doc(payload.taskId)
                .update('attachment', null)
            }

          } else if (payload.initialAttachmentUrl === null && payload.attachmentUrl !== null) {
            // directly upload attachmentUrl
            // create a storage ref
            let storageRef = storage.ref('personalTaskImages').child(payload.toDoListId).child(methods.uuidv4() + '.jpg')
            // upload file
            storageRef.put(payload.attachmentFile)
              .then(snapshot => {
                snapshot.ref.getDownloadURL().then(downloadUrl => {
                  db.collection('personal_to_do_lists/' + payload.toDoListId + '/tasks')
                    .doc(payload.taskId)
                    .update('attachment', downloadUrl)
                })
              })
          }
        })
    }
  },
  updateCollaborativeTask: ({state, rootGetters}, payload) => {
    db.collection('collaborative_to_do_lists/' + payload.toDoListId + '/tasks')
      .doc(payload.taskId)
      .update({
        assigneeId: payload.assigneeId,
        assigneeName: payload.assigneeName,
        attachment: payload.initialAttachmentUrl,
        completed: payload.completed,
        description: payload.description,
        dueDate: payload.dueDate !== null ? firebase.firestore.Timestamp.fromDate(methods.convertStringToDate(payload.dueDate)) : null,
        dueTime: payload.dueDate !== null ? methods.convertStringToDate(payload.dueDate).getTime() : 0,
        inboxTask: true,
        location: payload.location,
        priority: payload.priority,
        taskCreationDate: payload.taskCreationDate,
        taskCreationTime: payload.taskCreationTime,
        taskId: payload.taskId,
        taskName: payload.taskName,
        taskType: payload.taskType,
        toDoListId: payload.toDoListId,
        toDoListName: payload.toDoListName
      })
      .then(() => {
        // upload image to the storage and update the attachment link in the task
        if (payload.initialAttachmentUrl !== null && payload.attachmentUrl != null && payload.initialAttachmentUrl !== payload.attachmentUrl) {
          // remove initialAttachmentUrl and upload attachmentUrl
          const attachmentObject = payload.initialAttachmentUrl

          if (attachmentObject !== null) {
            const attachment = attachmentObject.toString()
            const attachmentRef = storage.refFromURL(attachment)

            attachmentRef.delete()
          }

          // create a storage ref
          let storageRef = storage.ref('collaborativeTaskImages').child(payload.toDoListId).child(methods.uuidv4() + '.jpg')
          // upload file
          storageRef.put(payload.attachmentFile)
            .then(snapshot => {
              snapshot.ref.getDownloadURL().then(downloadUrl => {
                db.collection('collaborative_to_do_lists/' + payload.toDoListId + '/tasks')
                  .doc(payload.taskId)
                  .update('attachment', downloadUrl)
              })
            })
        } else if (payload.initialAttachmentUrl !== null && payload.attachmentUrl === null) {
          // remove initialAttachmentUrl
          const attachmentObject = payload.initialAttachmentUrl

          if (attachmentObject !== null) {
            const attachment = attachmentObject.toString()
            const attachmentRef = storage.refFromURL(attachment)

            attachmentRef.delete()

            db.collection('collaborative_to_do_lists/' + payload.toDoListId + '/tasks')
              .doc(payload.taskId)
              .update('attachment', null)
          }

        } else if (payload.initialAttachmentUrl === null && payload.attachmentUrl !== null) {
          // directly upload attachmentUrl
          // create a storage ref
          let storageRef = storage.ref('collaborativeTaskImages').child(payload.toDoListId).child(methods.uuidv4() + '.jpg')
          // upload file
          storageRef.put(payload.attachmentFile)
            .then(snapshot => {
              snapshot.ref.getDownloadURL().then(downloadUrl => {
                db.collection('collaborative_to_do_lists/' + payload.toDoListId + '/tasks')
                  .doc(payload.taskId)
                  .update('attachment', downloadUrl)
              })
            })
        }
      })
  },
  inviteAdditionalCollaborator: ({state, rootGetters}, payload) => {
    db
      .collection('collaborative_to_do_lists')
      .doc(payload.toDoListId)
      .get()
      .then(doc => {
        const collaborativeToDoList = doc.data()

        let toDoListCollaboratorIdArray = collaborativeToDoList.toDoListCollaboratorId
        let invitedCollaboratorId = payload.currentToDoListCollaboratorId

        // add the collaboratorId of recently invited collaborator
        invitedCollaboratorId.forEach(collaboratorId => {
          toDoListCollaboratorIdArray.push(collaboratorId)
        })

        // update the toDoListCollaboratorId of the collaborative list
        db
          .collection('collaborative_to_do_lists')
          .doc(payload.toDoListId)
          .update('toDoListCollaboratorId', toDoListCollaboratorIdArray)

        const collaboratorListArray = payload.currentCollaboratorListArray
        const collaboratorRoleArray = payload.currentCollaboratorRoleArray

        collaboratorListArray.forEach((collaborator, index) => {

          const userCollaborativeToDoListParticipatedObject = {
            collaborativeToDoListId: payload.toDoListId,
            collaborativeToDoListName: payload.toDoListName,
            collaborativeToDoListRole: collaboratorRoleArray[index],
            collaboratorId: collaborator.id,
            collaboratorName: collaborator.name,
            collaboratorEmail: collaborator.email,
            collaboratorProfilePictureUrl: collaborator.profilePictureUrl !== undefined ? collaborator.profilePictureUrl : null,
            owner: false
          }

          db
            .collection('users/' + collaborator.id + '/user_collaborative_to_do_list_participation')
            .add(userCollaborativeToDoListParticipatedObject)
        })

        // notify the invited users about the collaborative list invitation
        const date = new Date();
        const notificationCreationTime = date.getTime()

        const collaborativeListInvitationNotification = {
          collaborativeToDoListId: payload.toDoListId,
          notificationMessage: "You have been invited to \"" + payload.toDoListName + '\"',
          notificationType: 'Invite Collaborator',
          notificationCreationTime: notificationCreationTime,
          notificationCreationDate: firebase.firestore.FieldValue.serverTimestamp()
        }

        // send the invitation notification to every invited user EXCEPT the owner
        toDoListCollaboratorIdArray.forEach(collaboratorId => {
          db
            .collection('users/' + collaboratorId + '/notifications')
            .add(collaborativeListInvitationNotification)
        })
      })
  }
}

const methods = {
  convertStringToDate(dateString) {
    const parts = dateString.split('-');
    // Please pay attention to the month (parts[1]); JavaScript counts months from 0:
    // January - 0, February - 1, etc.
    const newDate = new Date(parts[0], parts[1] - 1, parts[2]);
    return newDate
  },
  uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
